import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(main)/events/EventsLayoutShell.tsx");
